'use client';

import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { usePathname } from 'next/navigation';
import { UnauthQueryOptions } from '@/api';
import { resolveBenefitMenuGroups } from '../_utils/resolveBenefitMenuGroups';
export const useBenefitMenus = () => {
  const $ = _c(3);
  const pathname = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = UnauthQueryOptions["get:/wello/v2/allows/benefit-menus"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== pathname) {
    t1 = {
      ...t0,
      select: data => resolveBenefitMenuGroups(data?.context ?? [], pathname ?? "")
    };
    $[1] = pathname;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useSuspenseQuery(t1);
};